module.exports = __webpack_public_path__ + "fonts/CashSans-MediumItl.4869a46.woff2";